module.exports = __webpack_public_path__ + "assets/media/landing-page.3140c253.svg";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/OnboardingPlaybookTargetingStep/landing-page.svg
// module id = 3142
// module chunks = 0